/**
 * Generated by orval 🍺
 * Do not edit manually.
 * eddy-be
 * API documentation of eddy-be
 * OpenAPI spec version: 3.4.15
 */

export type FeatureFlagName = typeof FeatureFlagName[keyof typeof FeatureFlagName];


export const FeatureFlagName = {
  Y24Q3_UserResourceAccessV2: 'Y24Q3_UserResourceAccessV2',
  Y25Q3_CheatDetection: 'Y25Q3_CheatDetection',
  Y25Q3_UXUIRevampV1: 'Y25Q3_UXUIRevampV1',
  Y25Q3_UXUIRevampV2: 'Y25Q3_UXUIRevampV2',
  Y25Q3_GradeReadAloudAiBe: 'Y25Q3_GradeReadAloudAiBe',
  Y25Q3_Gamification: 'Y25Q3_Gamification',
  Y25Q3_EnableBulkImportV2: 'Y25Q3_EnableBulkImportV2',
  Y25Q3_ActivitySessionOptimization: 'Y25Q3_ActivitySessionOptimization',
  Y25Q3_NetworkIssueNotificationBar: 'Y25Q3_NetworkIssueNotificationBar',
  Y25Q4_BrowserRealtimeSpeechRecognition: 'Y25Q4_BrowserRealtimeSpeechRecognition',
  Y26Q1_GoogleSpeechRecognition: 'Y26Q1_GoogleSpeechRecognition',
  Y26Q2_UserAIVoiceSelector: 'Y26Q2_UserAIVoiceSelector',
  Y26Q2_UserNotebook: 'Y26Q2_UserNotebook',
  Y26Q2_TwoWayVoiceModel: 'Y26Q2_TwoWayVoiceModel',
  Y26Q2_GetDocByIdAllowMissingBug: 'Y26Q2_GetDocByIdAllowMissingBug',
  Y26Q2_GenerateMissingTwoWayMissingAttempt: 'Y26Q2_GenerateMissingTwoWayMissingAttempt',
  Y26Q2_FirebaseQueryInstrumentation: 'Y26Q2_FirebaseQueryInstrumentation',
  Y26Q3_ByStudentExportFromView: 'Y26Q3_ByStudentExportFromView',
  Y26Q3_B2B2CFlow: 'Y26Q3_B2B2CFlow',
  Y26Q3_MidtermAvatarUpdate: 'Y26Q3_MidtermAvatarUpdate',
  Y26Q3_ViewClassroomUserScoreV2Incremental: 'Y26Q3_ViewClassroomUserScoreV2Incremental',
  Y26Q3_AllowListeningToUserResponseOnError: 'Y26Q3_AllowListeningToUserResponseOnError',
  Y26Q3_VocabV2SenseEmbeddingFreshness: 'Y26Q3_VocabV2SenseEmbeddingFreshness',
  Y26Q3_ViewClassroomActivitySummaryV2Incremental: 'Y26Q3_ViewClassroomActivitySummaryV2Incremental',
  Y26Q3_ViewClassroomLessonSummaryV2Incremental: 'Y26Q3_ViewClassroomLessonSummaryV2Incremental',
  Y26Q4_LiveSession: 'Y26Q4_LiveSession',
  Y26Q4_TranscriptionEditor: 'Y26Q4_TranscriptionEditor',
  Y26Q4_BackToSchoolAvatarPromotion: 'Y26Q4_BackToSchoolAvatarPromotion',
  Y26Q4_InAppBrowserNotice: 'Y26Q4_InAppBrowserNotice',
} as const;
